const api_url   =   "http://ericgu178/";
export default {
    api_url,
};


// WEBPACK FOOTER //
// ./src/config/app.js